export default "__VITE_ASSET__DW_Piymy__"